import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialGlobalState";

const globalFunctionsSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setCurrentLevel: (state, action) => {
      state.currentLevel = action.payload;
    },
    setIsInputChecked: (state, action) => {
      state.isInputChecked = action.payload;
    },
    setQuizType: (state, action) => {
      state.quizType = action.payload;
    },
    setAreCompanyQuestionsShown: (state, action) => {
      state.areCompanyQuestionsShown = action.payload;
    },
    setCompanyQuestions: (state, action) => {
      state.companyQuestions = action.payload;
    },
    setIsFormComplete: (state, action) => {
      state.isFormComplete = action.payload;
    },
    setLevel: (state, action) => {
      state.level = action.payload;
    },
    setIsModalShown: (state, action) => {
      state.isModalShown = action.payload;
    },
    resetInitialState: () => {
      return initialState;
    },
    setIsQuizFinished: (state, action) => {
      state.quizFinished = action.payload;
    },
    setUserData: (state, action) => {
      const { email, fullname } = action.payload; // Extract values from action.payload
      state.userData.email = email;
      state.userData.fullname = fullname;
    },
    setIsLangModalShown: (state, action) => {
      state.isLangModalShown = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setIsCookieModalShown: (state, action) => {
      state.isCookieModalShown = action.payload;
    },
    setCookie: (state, action) => {
      const { name, value } = action.payload;
      state.cookies[name] = value;
    },
    setCookies: (state, action) => {
      for (let cookie in state.cookies) {
        state.cookies[cookie] = action.payload;
      }
    },
  },
});

export const {
  setCookies,
  setCookie,
  setIsCookieModalShown,
  setIsLangModalShown,
  setLanguage,
  setUserData,
  setIsQuizFinished,
  resetInitialState,
  setIsModalShown,
  setCurrentLevel,
  setIsInputChecked,
  setQuizType,
  setAreCompanyQuestionsShown,
  setCompanyQuestions,
  setIsFormComplete,
  setLevel,
} = globalFunctionsSlice.actions;

export default globalFunctionsSlice.reducer;
